import "./Loading.css";

const Loading = () => {
  return (
    <div className="wrapper">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
